<div class="modal-header">
  <div class="col-10 p-0">
     <h4 class="modal-title">{{ title }}</h4>
  </div>
  <div class="col p-0 text-end">
    <button type="button" class="btn btn-primary" aria-label="Close" (click)="activeModal.dismiss('Close')">
      <span class="fa fa-close"></span>
    </button>
  </div>
</div>
<div class="modal-body">
  {{ message }}
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="decline()">{{ btnCancelText }}</button>
  <button type="button" class="btn btn-primary" (click)="accept()">{{ btnOkText }}</button>
</div>
